import Vue from 'vue';
import SiteHeader from '../vue/SiteHeader.vue';
import SiteFooter from '../vue/SiteFooter.vue';
import IntroBanner from '../vue/IntroBanner.vue';
import CallToActionContainer from '../vue/CallToActionContainer.vue';
import CallToAction from '../vue/CallToAction.vue';
import NewsListing from '../vue/NewsListing.vue';
import NewsListingItem from '../vue/NewsListingItem.vue';
import SubscribeBanner from '../vue/SubscribeBanner.vue';
import PageBanner from '../vue/PageBanner.vue';
import TeamMemberContainer from '../vue/TeamMemberContainer.vue';
import TeamMember from '../vue/TeamMember.vue';
import InternalBanner from '../vue/InternalBanner.vue';
import PostBanner from '../vue/PostBanner.vue';
import InquireForm from '../vue/InquireForm.vue';
import PostShare from '../vue/PostShare.vue';

export default {
  init() {
    
    /* Vue
    ---------------------------------------------------------------------------------------------------- */
    
    Vue.config.productionTip = false;
    
    new Vue({
      data: {
        topScrollThreshold: 100,
        isScrolled: false,
      },
      
      components: {
        SiteHeader,
        SiteFooter,
        IntroBanner,
        CallToActionContainer,
        CallToAction,
        NewsListing,
        NewsListingItem,
        SubscribeBanner,
        PageBanner,
        TeamMemberContainer,
        TeamMember,
        InternalBanner,
        InquireForm,
        PostBanner,
        PostShare,
      },
      
      methods: {
        didScroll () {
          this.isScrolled = (window.scrollY > this.topScrollThreshold);
        },
      },
      
      created () {
        window.addEventListener('scroll', this.didScroll);
      },
      
      destroyed () {
        window.removeEventListener('scroll', this.didScroll);
      },
      
      mounted () {
          
      },
      
    }).$mount('#app');
    

  },
  finalize() {
  
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js